import React from 'react';
import { useFormContext, UseFormReturn } from 'react-hook-form';

export const ConnectForm = ({ children }: { children: (methods: UseFormReturn<any>) => JSX.Element }) => {
    const methods = useFormContext();

    return children({ ...methods });
};
